const MIN_NUMBER_OF_NIGHTS = 1
const MAX_NUMBER_OF_NIGHTS = 90
const MIN_OFFSET_DAYS = 0
const MAX_OFFSET_DAYS = 365

function putValueBetweenBoundaries (value, min, max) {
  if (!value || isNaN(value) || value < min) {
    value = min
  } else if (value > max) {
    value = max
  }

  return value
}

export default class HotelStayDatesFactory {
  constructor (dayOfWeekToDate, dateFactory) {
    this.dayOfWeekToDate = dayOfWeekToDate
    this.dateFactory = dateFactory
  }

  create (requestParams) {
    let {
      checkInDate,
      checkOutDate,
      day_of_week: dayOfWeekToDate,
      startDate,
      startDateOffsetDays,
      numberNights
    } = requestParams

    let parsedCheckInDate = null
    let parsedCheckOutDate = null

    startDateOffsetDays = putValueBetweenBoundaries(startDateOffsetDays, MIN_OFFSET_DAYS, MAX_OFFSET_DAYS)
    numberNights = putValueBetweenBoundaries(numberNights, MIN_NUMBER_OF_NIGHTS, MAX_NUMBER_OF_NIGHTS)

    if (dayOfWeekToDate) {
      parsedCheckInDate = this.dateFactory.addDays(this.dayOfWeekToDate(dayOfWeekToDate), parseInt(startDateOffsetDays))
      parsedCheckOutDate = this.dateFactory.addDays(parsedCheckInDate, parseInt(numberNights))
    } else if (startDate) {
      if (!isNaN(startDate)) {
        parsedCheckInDate = this.dateFactory.addDays(this.dateFactory.now(), parseInt(startDate))
      } else if (startDate.toLowerCase() === 'today') {
        parsedCheckInDate = this.dateFactory.now()
      } else if (startDate.toLowerCase() === 'tomorrow') {
        parsedCheckInDate = this.dateFactory.addDays(this.dateFactory.now(), 1)
      } else {
        parsedCheckInDate = this.dateFactory.dateFromPattern(startDate)
      }
      parsedCheckInDate = this.dateFactory.addDays(parsedCheckInDate, parseInt(startDateOffsetDays))
      parsedCheckOutDate = this.dateFactory.addDays(parsedCheckInDate, parseInt(numberNights))
    } else if (isDateString(checkInDate) && isDateString(checkOutDate)) {
      parsedCheckInDate = this.dateFactory.dateFromPattern(checkInDate)
      parsedCheckOutDate = this.dateFactory.dateFromPattern(checkOutDate)
    }

    return {
      checkInDate: parsedCheckInDate,
      checkOutDate: parsedCheckOutDate
    }

    function isDateString (string) {
      const date = new Date(string)
      return (date !== 'Invalid Date' && !isNaN(date))
    }
  }
}
